import { render, staticRenderFns } from "./BaseFooterOneHundred.vue?vue&type=template&id=31ac1cf4&"
import script from "./BaseFooterOneHundred.vue?vue&type=script&lang=js&"
export * from "./BaseFooterOneHundred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports